import React, { useState } from 'react';
import logo from '../assets/MyDataLogo60px.png';
import { Navbar, NavList, NavItem, Title, Dropdown, DropdownContent, ProfileImage, HeaderLH, Button } from './StyledComponents';
import { Link } from 'react-router-dom';

const Header = ({ user, isAdmin, onLogout, onSettings, onCustomizeWidgets, onReportBug }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  return (
    <HeaderLH className="App-header">
      <table>
        <tbody>
          <tr>
            <td rowSpan={2}>
              <img src={logo} alt="My Data Logo" className="App-logo" />
            </td>
            <td rowSpan={2} style={{ width: '100%', textAlign: 'center' }}>
              <Title>My Data</Title>
            </td>
            <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
              <Navbar>
                <NavList>
                  {onReportBug && (
                    <NavItem>
                      <Button style={{ padding: '6px 12px' }} onClick={(e) => { e.preventDefault(); onReportBug(); }}>Report Bug</Button>
                    </NavItem>
                  )}
                  <NavItem><Link to="/overview">Overview</Link></NavItem>
                  <NavItem><Link to="/accounts">Accounts</Link></NavItem>
                  <NavItem><Link to="/transactions">Transactions</Link></NavItem>
                  {user && (
                    <NavItem>
                      <Dropdown onClick={toggleDropdown}>
                        <ProfileImage
                          src={user.photoURL}
                          alt="Profile"
                          referrerPolicy="no-referrer"
                        />
                        {isDropdownOpen && (
                          <DropdownContent onClick={(e) => e.stopPropagation()}>
                            {onCustomizeWidgets && (
                              <Button onClick={(e) => {
                                e.preventDefault();
                                setIsDropdownOpen(false);
                                onCustomizeWidgets();
                              }}>Customize Widgets</Button>
                            )}
                            {isAdmin && (
                              <Link to="/admin" onClick={() => setIsDropdownOpen(false)}>
                                Admin
                              </Link>
                            )}
                            <a href="#settings" onClick={(e) => {
                              e.preventDefault();
                              setIsDropdownOpen(false);
                              onSettings();
                            }}>Settings</a>
                            <Button onClick={(e) => {
                              e.preventDefault();
                              setIsDropdownOpen(false);
                              onLogout();
                            }}>Logout</Button>
                          </DropdownContent>
                        )}
                      </Dropdown>
                    </NavItem>
                  )}
                </NavList>
              </Navbar>
            </td>
          </tr>
        </tbody>
      </table>
    </HeaderLH>
  );
};

export default Header;
